import i18next from 'i18next';

i18next.addResources('es', 'sectionSelector', {
  allSections: 'Todas',
  sections: 'Secciones',
  project: 'Proyectos',
  article: 'Contenidos',
  event: 'Eventos'
});

i18next.addResources('en', 'sectionSelector', {
  allSections: 'All',
  sections: 'Sections',
  project: 'Projects',
  article: 'Content',
  event: 'Events'
});

i18next.addResources('pt', 'sectionSelector', {
  allSections: 'Todas',
  sections: 'Seções',
  project: 'Projetos',
  article: 'Conteúdo',
  event: 'Eventos'
});
